import { DateTimeFactory } from "../../../../localization/useDateTime"
import { ProductGroup, ProductGroupFormValues } from "../productGroupTypes"

export const prepareInitialValues = (
    dateTimeFactory: DateTimeFactory,
    productGroup?: ProductGroup,
): ProductGroupFormValues => {
    const timeIntervalStart = dateTimeFactory.fromISO(productGroup?.availabilityDetails?.timeInterval?.start ?? "10:00")
    const timeIntervalEnd = dateTimeFactory.fromISO(productGroup?.availabilityDetails?.timeInterval?.end ?? "12:00")

    return {
        name: productGroup?.name ?? "",
        isActive: productGroup?.isActive ?? true,
        productGroupCode: productGroup?.productGroupCode ?? undefined,
        availableTime: productGroup?.availabilityDetails !== undefined,
        weekDays: productGroup?.availabilityDetails?.weekDays ?? [],
        timeIntervalStart,
        timeIntervalEnd,
        isLocked: productGroup?.securitySettings?.isLocked ?? false,
    }
}
